<template>
    <v-layout row wrap style="margin:0" v-if="searchedcompanydata">
        <v-flex md7 sm12 xs12 class="p-4">
            <v-layout column>
                <div class="J-container--box" v-if="searchedcompanydata.office[0].location !==undefined">
                    <h1 class="J-title-profile">{{searchedcompanydata.name.toLowerCase()}}</h1>
                    <hr>
                    <p>{{searchedcompanydata.description}}</p>
                
                    <div class="J-container-d">
                        <div class="J-d-leyend">
                            <div class="J-d-leyend-decoration principal">

                            </div>
                            <div class="J-d-leyend-text">
                                Sede principal
                            </div>
                        </div>

                        <div class="J-d-leyend">
                            <div class="J-d-leyend-decoration">
                                
                            </div>
                            <div class="J-d-leyend-text">
                                Sedes
                            </div>
                        </div>
                    </div>
                    <div v-if="searchedcompanydata.office[0].location !==undefined" class="hidden-sm-and-down" id="map-wrap" :style="'height:600px;position:relative; z-index:1'">
                            <l-map :zoom=12 :center="[searchedcompanydata.office[0].location[1],searchedcompanydata.office[0].location[0]]">
                                <l-tile-layer url="http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"></l-tile-layer>
                                <!--
                                <l-marker v-for="locationvenues in searchedcompanydata[0].office" :key="locationvenues.length" :lat-lng="[locationvenues.location[0], locationvenues.location[1]]">
                                    <l-icon v-if="locationvenues.isvenueprincipal === true"
                                        :icon-size="40"
                                        :icon-anchor="18"
                                        icon-url="/img/icons/building.png" >
                                    </l-icon>
                                    <l-icon v-if="locationvenues.isvenueprincipal === false"
                                        :icon-size="40"
                                        :icon-anchor="18"
                                        icon-url="/img/icons/house-icon.png" >
                                    </l-icon>
                                    <l-popup>
                                        <label>{{locationvenues.name}}</label>
                                    </l-popup>
                                </l-marker>
                                -->
                                <div v-for="(item,index) in searchedcompanydata.office" :key="index">
                                    <l-circle-marker  v-if="item.isvenueprincipal===true" :lat-lng="[item.location[1],item.location[0]]" fillColor="#F35369" :fillOpacity="1" color="#fff">
                                        <l-popup>
                                            <button class="btn btn-warning btn-sm" style="color: white;margin:5%" @click="selectLocal(item)">Seleccionar</button>
                                        </l-popup>
                                    </l-circle-marker>
                                    <l-circle-marker v-if="item.isvenueprincipal===false" :lat-lng="[item.location[1],item.location[0]]" fillColor="#07e8f4" :fillOpacity="1" color="#fff">
                                        <l-popup>
                                            <button class="btn btn-warning btn-sm" style="color: white;margin:5%" @click="selectLocal(item)">Seleccionar</button>
                                        </l-popup>
                                    </l-circle-marker>
                                </div>
                            </l-map>
                    </div>
                </div>
            </v-layout>
        </v-flex >
        <v-flex md5 sm12 xs12  class="p-4">
            <div
                id="e3"
                style=" margin: auto;"
                class="lighten-3">
                    <component-conversation v-if="tabs[0].active" :data_conversation="office" :is_company="false" @back="isTabActive"/>
                    <div v-if="tabs[1].active">
                        <div v-if="searchedcompanydata.office.length > 0">
                            <div v-for="(sede,e) in fourdatasearchedcompanydata" :key="e+1" style="bottom-top:20px">
                                <div class="J-container J-office-container">
                                    <v-layout class="J-office-items" >
                                        <div class="J-office-img-content">
                                            <div class="J-office-img">
                                                <img :src="sede.image_office.length > 0 ? sede.image_office[0].link : 'https://cdn.vuetifyjs.com/images/cards/foster.jpg'" alt="">
                                            </div>
                                        </div>
                                        <div class="J-office-text">
                                            <div class="primary-title">
                                                <a href="javascript:void(0)" data-toggle="tooltip" title="editar sede">
                                                    <div class="headline">{{sede.name}}</div>
                                                    <div>{{sede.address}}</div>
                                                </a>
                                                <div v-if="sede.location===undefined"  style="color:red">
                                                    <i class="fas fa-exclamation-triangle"> </i>
                                                    Sin dirección
                                                </div>
                                            </div>
                                        </div>
                                    </v-layout>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="tabs[2].active" class="">
                        <div class="J-chat-container J-conversation">
                            <div class="J-chat-avatar-content">
                                <a href="javascript:void(0)" @click="isTabActive(1)" class="J-icon-back">
                                    <i class="fas fa-angle-left"></i>
                                </a>
                                <v-avatar size="60px">
                                    <img :src="imageUrl" alt="Avatar">
                                </v-avatar>
                                <div class="J-chat-message-content">
                                    <div class="J-chat-name">
                                        <span>
                                            {{office.name}}
                                        </span>
                                    </div>
                                    <div class="J-chat-date">
                                        <span>
                                            Activo
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <component-listcart class="J-color-fondo" v-if="tabs[2].active"/>
                        </div>
                    </div>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
import env from '../../../../config/env.example'
import { EventBus } from '../../../../helpers/eventbus/event-bus'
import initVue from '../../../../helpers/initVue'
import conversation from '../Chat/conversation'
import { LMap, LTileLayer, LMarker,LPopup,LCircle,LCircleMarker, LIcon, } from 'vue2-leaflet';
import listcart from '@/components/partials/listcart.vue'
import {Office} from '@/models/index'
import {CompanyStorage,CartStorage,OrderStorage,OrderDetailStorage} from '@/helpers/storage'
const alertify = require('alertifyjs')
import {
    mapGetters
} from 'vuex'

export default {
    
    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),
    props:{
        id_company:{required:false,default:null}
    },
    data(){
        return {
            tabs:[
                {title:'message',active:false},
                {title:'office',active:true},
                {title:'detail',active:false},
            ],
            identity: null,
            session: false,
            token: null, 
            n:4,
            iconSize: 64,
            latitude:-12.0454324, longitude:-75.2376588,
            buttonchossedfavorite: false,
            imageUrl: 'https://picsum.photos/510/300?random',
            imageFile:'',
            searchedcompanydata:[],
            fourdatasearchedcompanydata:[],

            companyservices: [],
            datafavoritelaundries: [],
            isadmin: false,
            nametitle:'',

            cartStorage:new CartStorage(),
            companyStorage:new CompanyStorage(),
            orderStorage:new OrderStorage(),
            orderDetailStorage:new OrderDetailStorage(),
            office:new Office()
        }
    },
    components:{
        'component-listcart':listcart,'component-conversation':conversation, LMap, LIcon, LTileLayer, LMarker,LPopup,LCircle,LCircleMarker
    },
    async created(){
        this.getidentity()
        await this.getdatacompanybysearchinrucorname()
        this.showusersfavoritelaundries()
        EventBus.$on('getdatacompanybysearchinrucorname', () =>{
            this.getdatacompanybysearchinrucorname()
            this.showusersfavoritelaundries()
        })
        
            var order=this.orderStorage.get();
            if(order){
                var company=this.companyStorage.get();
                this.seartchOffice(company.id_office)
                this.isTabActive(1);
                this.isTabActive(2);

            }
        
        
    },
    mounted(){
        //this.getdatacompanybysearchinrucorname()
    },
    methods:{
        selectLocal:function(data){
            var dataCompany=this.searchedcompanydata;
            //console.log(dataCompany)

            this.companyStorage.remove();
            this.orderStorage.remove();
            this.cartStorage.remove();
            this.orderDetailStorage.remove();
            var storage={
                id_company:dataCompany._id,
                id_office:data._id,
                name_sede:data.name,
                name_company:dataCompany.name,
                latitude:data.location[0],
                longitude:data.location[1],
            }
            this.companyStorage.set(storage);
            this.$router.push(`/services/${dataCompany._id}`)
        },
        seartchOffice:function(id){
            var offices=this.searchedcompanydata.office;
            var index=offices.findIndex(element=>element._id==id);
            if(index>-1){
                //console.log(this.office)
                this.office=offices[index];
                //console.log(this.office)
            }
        },
        selectedOffice:function(sede){
            if(this.session){
                this.office=sede;
                this.office.id=this.office._id
                this.isTabActive(0)
            }
            
        },
        isTabActive:function(index){
            //console.log(index);
            this.tabs.forEach(element=>{
                element.active=false;
            });
            this.tabs[index].active=true;
        },
        routeDirectiontoadminpanel:function(){
            window.location = `${env.host}empresa/created/${this.searchedcompanydata._id}`
            //this.$router.push('/empresa/created/'+_id);
        },

        deletefavoritelaundry(){
            //console.log(this.searchedcompanydata[0])
            this.buttonchossedfavorite = null
            this.axios.delete(`users/deletefavoritecompanies/${this.searchedcompanydata._id}`)
            .then(()=>{
                //console.log(res)
                this.showusersfavoritelaundries()
            })
            
        },

        isadmininthiscompany(){
            let idcompany = this.searchedcompanydata._id
            if(this.session){
                this.axios.get(`company/isadmininthiscompany/${this.identity._id}/${this.token}/${idcompany}`)
                .then(res=>{
                    if(res.data !=null){
                        this.isadmin = res.data.isadmin
                        //console.log(this.isadmin)
                    }
                })
            }
        },

        showusersfavoritelaundries(){
            if(this.session){
                this.buttonchossedfavorite = null
                this.axios.get(`users/showfavoritecompanies/${this.identity._id}/${this.token}`)
                .then(res=>{
                    //console.log(res.data)
                    if(res.data.data === undefined){
                        this.buttonchossedfavorite = false
                    }else{
                        this.datafavoritelaundries = res.data.data.companies
                        
                        let comparatearrayfavoritelaundries = this.datafavoritelaundries.some((datafavoritelaundries)=>{
                            return datafavoritelaundries._idcompany.match(this.searchedcompanydata._id)
                        })
                        //console.log(comparatearrayfavoritelaundries)
                        this.buttonchossedfavorite = comparatearrayfavoritelaundries
                    }
                })
                
            }
        },

        choosingfavoritelaundry(){
            this.buttonchossedfavorite = null
            //console.log(this.chossedfavoritecompany)
            this.axios.post(`users/choosefavoritecompany/${this.identity._id}/${this.token}/${this.searchedcompanydata._id}`)
            .then(()=>{
                //console.log(res)
                //this.buttonchossedfavorite = true
                this.showusersfavoritelaundries()
                EventBus.$emit('showusersfavoritelaundries')
            })
            .catch(err=>{
                //console.log(err)
                let messageerror = err.response.data.message
                let onehundredaplication = messageerror === 'only one hundred aplications'
                if(onehundredaplication){
                    alertify.error('Solo puede tener 100 aplicaciones favoritas')
                }
            })
        },
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            
        },
        async getdatacompanybysearchinrucorname(){
            let datacompany = this.$route.params.datacompany
            if(!datacompany)  datacompany=this.id_company;
            //console.log(datacompany)
            await this.axios.get(`company/searchbyrucornamecompany/${datacompany}`)
            .then((res)=>{
                this.searchedcompanydata = res.data.company
                //console.log(this.searchedcompanydata)
                
                document.getElementsByTagName('title')[0].innerHTML = `${this.searchedcompanydata.name}`
                this.nametitle = this.searchedcompanydata.name
                this.fourdatasearchedcompanydata = this.searchedcompanydata.office
                console.log(this.fourdatasearchedcompanydata)
                if(res.data.company.image_company.length>0){
                    this.imageUrl = res.data.company.image_company[0].link;
                    this.imageFile = '';
                    this.imageName = res.data.company.image_company[0].link;
                }
                if(this.searchedcompanydata.office.length <=1){
                    this.companyservices = this.searchedcompanydata.services
                }
                this.isadmininthiscompany()
            })
            .catch((err)=>{
            })
        }

    }
}
</script>
